<template>
    <c-input-element :label="label" :helptext="helptext" :class="{ 'c-form-element--horizontal' : horizontal }" :name="name">
        <select v-bind="$attrs" v-model="value"  :id="$.uid" :class="{'bg-white' : whiteBg}">
            <option value='' disabled selected hidden>{{placeholder}}</option>
            <option v-for="option in options" :key="option.id" :value="getName(ValueName, option)">{{getName(DisplayName ?? name, option)}}</option>
        </select>
    </c-input-element>
</template>

<script>
import Input from '@mixins/Input';

export default {
    name: 'form-select-input',
    inheritAttrs: false,
    mixins: [Input],
    props: {
        placeholder: {
            type: String,
            required: false,
            default: 'Selecteer een optie'
        },
        options: {
            required: true
        },
        name: {
            required: true
        },
        ValueName: {
            default: 'name'
        },
        DisplayName: {
            default: null,
        },
        required: {
            type: Boolean,
            default: false
        },
        whiteBg: {
            type: Boolean,
            default: false
        },
        displaySeperator: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getName(name, option){
            if (name instanceof Function) {
                return name(option);  
            }
            if ((name instanceof String || typeof(name) === 'string') && name) {
                if(this.displaySeperator){
                    return name.split(',').map(name => name.match(/^'(.*)'$/)?.[1] ?? option[name]).join(' | ');
                }
                else {
                    return name.split(',').map(name => name.match(/^'(.*)'$/)?.[1] ?? option[name]).join(' ');
                }
            }
            return option;
        },
    },
}
</script>